module.exports = __webpack_public_path__ + "img/mono_20.cbbb252d.png";